import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { ReactComponent as Icon } from '#web-components/assets/icons/info.svg';

import styles from './InfoIcon.styles';

type InfoIconProps = {
  className?: string;
};

const useStyles = makeStyles(styles, { name: 'InfoIcon' });

export default function InfoIcon({ className }: InfoIconProps) {
  const classes = useStyles();
  return (
    <span className={clsx(classes.icon, className)}>
      <Icon />
    </span>
  );
}
